/**
 * Define constants for common event values.
 */
export class ThomasEventTypes {
  static COMPONENT_TYPE_PAGE = "page" as const;

  static COMPONENT_TYPE_RFQ = "rfq" as const;

  static ACTION_TYPE_CLICK = "click" as const;

  static ACTION_TYPE_SUBMIT = "submit" as const;

  static ACTION_TYPE_ERROR = "error" as const;

  static ACTION_TYPE_VIEW = "view" as const;

  static ACTION_TYPE_IMPRESSION = "impression" as const;

  static THOMAS_EVENT_NAME = "tnevent" as const;
}
